import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable()
export class PhotoService {

    constructor(private http: HttpClient) {
    }

    photos = [];

    getPhotos() {
        let url = `${environment.apiUrl}panoramaphoto/?app=27&limit=1000`;
        let promise = this.http.get(url).toPromise();

        promise.then(data => {
            this.photos = data['objects'];
        });
        return promise;
    }

    getPhoto(id) {
        return new Promise((resolve, reject) => {
            this.getPhotos().then(data => {
                resolve(this.photos[id])
            });
        });
    }
}



// WEBPACK FOOTER //
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/app/shared/photo.service.ts